import _ from 'lodash';
import { connect } from 'react-redux';

/**
 * Higher Level component that tags on the Feature Flag props
 * onto any component.
 */

// NOTE: To use dispatch(fetchFeatures())
// must be added to the preload at the root level of page: (found in containers/root-apps/base.js)
export default function loadFeatures(Component) {
  const mapStateToProps = (state, ownProps) => ({
    features: _.get(state, 'common.features'),
    ...ownProps,
  });

  return connect(mapStateToProps)(Component);
}



// WEBPACK FOOTER //
// ./app/common/containers/features.js